module.exports = __webpack_public_path__ + "static/fauxmarketcap-43e0e30fd4983adb830024e0ff0635c7.png";